// export { default as ExpandDrawer } from './column-width-icon_1.svg';
import React from "react";
export const ExpandDrawer = () => (
  <svg
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    x="0px"
    y="0px"
    viewBox="0 0 512 512"
    style={{ width: "2rem", fill: "#71afb4" }}
  >
    <g>
      <path
        d="M43.5,41H5.1C2.3,41,0,43.3,0,46.1v419.8c0,2.8,2.3,5.1,5.1,5.1h38.4c2.8,0,5.1-2.3,5.1-5.1V46.1
            C48.6,43.3,46.3,41,43.5,41z M506.9,41h-38.4c-2.8,0-5.1,2.3-5.1,5.1v419.8c0,2.8,2.3,5.1,5.1,5.1h38.4c2.8,0,5.1-2.3,5.1-5.1V46.1
            C512,43.3,509.7,41,506.9,41z M430.9,251.1l-81.7-64.4c-2-1.6-4.9-1.2-6.5,0.8c-0.6,0.8-1,1.8-1,2.9V233H170.2v-40.2
            c0-3.8-4.5-6-7.5-3.6l-81.7,64.5c-2,1.5-2.4,4.4-0.8,6.4c0.2,0.3,0.5,0.6,0.8,0.8l81.6,64.5c3,2.4,7.5,0.3,7.5-3.6V279h171.5v40.2
            c0,3.8,4.5,6,7.5,3.6l81.6-64.5C433.2,256.5,433.2,252.9,430.9,251.1z"
      />
    </g>
  </svg>
);
